import { useEffect } from "react";
import { useTable, useTableActions } from "../TableContext";

/**
 * Hook pour gérer la recherche avec debounce
 */
export const useTableSearch = (debounceMs: number = 500) => {
  const { state } = useTable();
  const { setSearchString, clearSearch } = useTableActions();

  useEffect(() => {
    const handler = setTimeout(() => {
      // Le middleware gère déjà le fetch automatique
    }, debounceMs);

    return () => clearTimeout(handler);
  }, [state.searchString, debounceMs]);

  return {
    searchString: state.searchString,
    setSearchString,
    clearSearch
  };
};
